import { createStore, applyMiddleware } from 'redux';
import reducer from './reducers/index';
import thunk from 'redux-thunk';
import initialState from './states';

export const store = createStore(
	reducer,
	initialState,
	applyMiddleware(thunk),
);